// src/services/api.js
import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

// Create an Axios instance
const api = axios.create({
  baseURL: API_BASE_URL, // centralized backend URL
  headers: {
    "Content-Type": "application/json",
  },
});

// Optional: Add auth token interceptor if needed
api.interceptors.request.use((config) => {
  if (config.headers?.Authorization) {
    return config;
  }
  const path = String(config.url || "");
  const token = path.startsWith("/api/admin")
    ? localStorage.getItem("adminToken")
    : localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
